import { InjectionToken } from '@angular/core';
export var VARIABLE_SERVICE = new InjectionToken('VARIABLE_SERVICE');
